import { accountList } from '@/mocks/homeData';

export default function AccountsSection() {
  return (
    <section id="accounts" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="text-xs font-medium text-primary-700 tracking-wide flex items-center gap-2">
            <span className="w-6 h-px bg-primary-300"></span>
            账号动向
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            微博与抖音，最新动态都在这里
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            认准认证标识再关注。以下整理了吃瓜捷克两个主力平台的账号状态与最近动向，
            点按钮即可跳到对应主页查看实时内容。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {accountList.map((a) => (
            <div key={a.platform} className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl ${a.tone}`}>
                  <i className={a.icon} aria-hidden="true"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="text-base font-medium text-foreground-950">{a.platform} · {a.handle}</h3>
                    <span className="inline-flex items-center gap-1 text-[11px] text-accent-800 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      <i className="ri-verified-badge-line" aria-hidden="true"></i>
                      {a.verified}
                    </span>
                  </div>
                  <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{a.desc}</p>
                </div>
              </div>

              <div className="mt-5 grid grid-cols-3 gap-3 border-t border-background-200 pt-4">
                <div>
                  <div className="text-lg font-heading font-semibold text-foreground-950">{a.followers}</div>
                  <div className="text-[11px] text-foreground-500 mt-0.5">粉丝数</div>
                </div>
                <div>
                  <div className="text-lg font-heading font-semibold text-foreground-950">{a.posts}</div>
                  <div className="text-[11px] text-foreground-500 mt-0.5">累计作品</div>
                </div>
                <div>
                  <div className="text-lg font-heading font-semibold text-foreground-950">{a.update}</div>
                  <div className="text-[11px] text-foreground-500 mt-0.5">最近更新</div>
                </div>
              </div>

              <div className="mt-4 rounded-lg bg-background-100 border border-background-200 px-4 py-3">
                <p className="text-[11px] text-foreground-400 flex items-center gap-1.5">
                  <i className="ri-quote-text" aria-hidden="true"></i>
                  最新动态摘录
                </p>
                <p className="mt-1.5 text-sm text-foreground-800 leading-relaxed">{a.lastPost}</p>
              </div>

              <div className="mt-4 flex flex-wrap gap-3">
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 px-4 py-2 rounded-md whitespace-nowrap"
                >
                  打开官方主页
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
                <a
                  href="#photos"
                  className="inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-background-100 text-foreground-800 border border-background-200 hover:bg-background-200 px-4 py-2 rounded-md whitespace-nowrap"
                >
                  看相关图集
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-4 text-xs text-foreground-400 flex items-center gap-1.5">
          <i className="ri-shield-check-line" aria-hidden="true"></i>
          同名人气较高，出现过仿冒号。请务必以带「已认证」标识的账号为准，谨防外链诈骗。
        </p>
      </div>
    </section>
  );
}